import { createWithEqualityFn } from 'zustand/traditional';
import { devtools } from 'zustand/middleware';

type TSite = {
  data: unknown | null;
  setData: (data: unknown) => void;
};

export const useSite = createWithEqualityFn<TSite>()(
  devtools(
    (set) => ({
      data: null,
      setData: (data: unknown) => {
        set(() => ({ data }), false, 'setData');
      },
    }),
    {
      name: '@jstore-site',
    }
  )
);
